/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { ToolsStatusTypes, ToolsStatusState } from './types';

const INITIAL_STATE: ToolsStatusState = {
  tools_status: [],
  request: {
    loading: false,
    loaded: false,
    error: false,
  },
};
const reducer: Reducer<ToolsStatusState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case ToolsStatusTypes.GET_TOOLS_STATUS_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ToolsStatusTypes.GET_TOOLS_STATUS_SUCCESS:
        draft.tools_status = result?.data?.tools;
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ToolsStatusTypes.GET_TOOLS_STATUS_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case ToolsStatusTypes.DELETE_INCIDENT_REQUEST:
        draft.request = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case ToolsStatusTypes.DELETE_INCIDENT_SUCCESS:
        draft.request = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case ToolsStatusTypes.DELETE_INCIDENT_FAILURE:
        draft.request = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
